import { render, staticRenderFns } from "./CustomerComponents.vue?vue&type=template&id=bbefefa4&"
import script from "./CustomerComponents.vue?vue&type=script&lang=js&"
export * from "./CustomerComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports